var BASEURLfix ="";

const BASEURL= ()=>{
    if(BASEURLfix===''){
   return fetch('/GetData2')
    .then(response => response.json())
    .then(data =>{
        BASEURLfix=data;
      return data
    });}
    else return BASEURLfix;
  }
export default BASEURL;